import { Modal } from 'bootstrap';
import { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import uuid from 'react-uuid';
import TapIcon from '../../../services/TapIcon';
import TapSelect from '../../../components/ui/TapSelect';
import Loader from '../../../components/ui/Loader/Loader';
import { useParams } from 'react-router-dom';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import { toast } from 'react-toastify';

function AssetComplianceDocModal({getComplianceData}, ref) {

    const modalId                   =   uuid();
    const modalElementRef           =   useRef();
    const modalRef                  =   useRef();

    const { id }                    =   useParams();   

    const formDataUrl               =   `${IAM_API_BASE_URL_2}/asset_compliance/document_form_data/${id}`;
    const addDocUrl                 =   `${IAM_API_BASE_URL_2}/asset_compliance/document`;

    const access_token              =   useSelector(state => state.auth.access_token);
    const [loadingForm, setLoadingForm] =   useState(false);
    const [docTypes, setDocTypes]   =   useState([]);

    const [documentSubmitting, setDocumentSubmitting]   =   useState(false);
    const [addDocumentForm, setAddDocumentForm] =   useState({
        name                :   "Asset Compliance",
        number              :   "",
        file                :   null,
        file_name           :   null,
        base64_document     :   null,
        asset_id            :  id,
        compliance_type_id  :  ''
    });

    useImperativeHandle(ref, () => ({
        initModalHandler: () => {   
            docTypes.length === 0 && formDataApi(); 
            openModal()
        }
    }));

    useEffect(() => {
        modalElementRef.current             =   document.getElementById(modalId);
        modalRef.current                    =   new Modal(modalElementRef.current, {keyboard: false, backdrop :false});
        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
        };
    }, []);
        
    const openModal                 =   () => {
        if (modalRef.current) {
            modalRef.current.show();
        }
    }
    const closeModal                =   () => {
        setAddDocumentForm({
            name                :   "Asset Compliance",
            number              :   "",
            file                :   null,
            file_name           :   null,
            base64_document     :   null,
            asset_id            :   id,
            compliance_type_id  :   ''
        });
        modalRef.current.hide();
    }

    const formDataApi               =   async ()  => {
        setLoadingForm(pre => !pre);
        const formData  =   await HttpAPICall.withAthorization("GET", formDataUrl, access_token, {}, {});

        formData.data && formData.data.length > 0 && setDocTypes(formData.data.map(d => ({label : d.compliance_name, value : d.compliance_type_id})))
        setLoadingForm(pre => !pre);
    }

    const handleFileChange = async (e) => {
        let file = e.target.files[0];
        let filename = file.name;
        const base64 = await convertBase64(file);
        setAddDocumentForm(prevForm => ({ ...prevForm, base64_document: base64, file_name: filename }));
    };

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result.replace("data:", "").replace(/^.+,/, ""));
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };


    const submitForm        =   async (e) => {
        e.preventDefault();

        setDocumentSubmitting(pre => !pre);

        const frmData       =   {
            name                :   addDocumentForm.name,
            number              :   addDocumentForm.number,
            file_name           :   addDocumentForm.file_name,
            base64_document     :   addDocumentForm.base64_document,
            asset_id            :   id,
            compliance_type_id  :   addDocumentForm.compliance_type_id
        };

        const res  =   await HttpAPICall.withAthorization("POST", addDocUrl, access_token, {}, frmData);
        
        res.data && toast.success(res.data.msg, { position: toast.POSITION.TOP_RIGHT });
        closeModal();
        getComplianceData();

        setDocumentSubmitting(pre => !pre);
    }


  return (
    <>
        <div className="modal fade" id={modalId} ref={modalElementRef} tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Document</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" disabled={documentSubmitting} onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {
                            loadingForm 
                            ? <Loader/>
                            :
                            <form onSubmit={submitForm} id={modalId+"Form"} method="post">
                                <div className="row align-items-center my-3">
                                    <div className="row align-items-center">
                                            <div className="col-md-3">
                                                <label className="form-label require">Document Type</label>
                                            </div>
                                            <div className="col-sm-7">
                                                <TapSelect
                                                    options={docTypes}
                                                    changeEvent={(selectedOption) => setAddDocumentForm({
                                                         ...addDocumentForm, 
                                                         name:  selectedOption ? selectedOption.label : '', 
                                                         compliance_type_id : selectedOption ? selectedOption.value : '' 
                                                    })}
                                                    value={docTypes.find(u => addDocumentForm.compliance_type_id === u.value)}
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    placeholder="Select Document Type"
                                                    autoComplete="off"
                                                    required={true}
                                                    autoFocus={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-sm-3">
                                                <label className="form-label">Document Number</label>
                                            </div>
                                            <div className="col-md-7">
                                                <input
                                                    name="number"
                                                    type="text"
                                                    value={addDocumentForm.number}
                                                    onChange={(e) => setAddDocumentForm({ ...addDocumentForm, number: e.target.value })}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    placeholder="Enter Document Number"
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-md-3">
                                                <label className="form-label require">Document</label>
                                            </div>
                                            <div className="col-md-7">
                                                <input
                                                    name="file"
                                                    type="file"
                                                    onChange={(e) => {
                                                        handleFileChange(e);
                                                    }}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    required={true}
                                                />
                                            </div>
                                        </div>
                                </div>
                            </form>
                        }
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" disabled={documentSubmitting || loadingForm} data-bs-dismiss="modal" onClick={closeModal}>Close</button>
                        <button type="submit" form={modalId+"Form"} disabled={documentSubmitting || loadingForm} className="btn btn-primary">Save {documentSubmitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default forwardRef(AssetComplianceDocModal);